import angular = require("angular");
import TPL = require("templates");
import {Config} from "../../config";

export class SearchDescriptionDirective {

  template = TPL.contentDirectives.searchDescription;
  scope = {
    params: "=params"
  };
  link;

  constructor(location, $log) {
    this.link = (scope, el, attrs) => {
      scope.vm = {
        goTo : (city) => {
          $log.debug("goTo");
          $log.debug(city);

          location.url(Config.home + "/" + city.url);
        },
        getUrl(city) {
          return "#" + Config.home + "/" + city.url;
        }
      }
    };
  }

  static factory() {
    var tmp = (a, b) => new SearchDescriptionDirective(a, b);
    tmp.$inject = ["$location", "$log"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/searchDescription.ts
 **/